import LinkInlineArrowLong from './LinkInlineArrowLong'

export default LinkInlineArrowLong
